import React, { useMemo } from "react";

export const Dust = ({ count = 24 }) => {
  const particles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 16,
        duration: 12 + Math.random() * 18,
        size: 1 + Math.random() * 2.5,
        opacity: 0.4 + Math.random() * 0.4,
      })),
    [count]
  );

  return (
    <div className="dust" aria-hidden="true">
      {particles.map((p, i) => (
        <span
          key={i}
          style={{
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            opacity: p.opacity,
          }}
        />
      ))}
    </div>
  );
};

export default Dust;
